module.exports = __webpack_public_path__ + "img/MemberCard4.8d334f23.jpg";